{
  "anySpecialist": {
    "text": "Fa‘aali mai le tele o taimi avanoa e mafai ona ou filifilia.",
    "title": "E leai se eseesega mo aʻu"
  },
  "nextLabel": "$t(common:next): <b>Filifili se taimi</b>",
  "profile": "Tala o le Fomaʻi Faapitoa",
  "specialists": {
    "00000000-0000-da7a-0003-000000000004": {
      "name": "Dr. Lopez"
    }
  },
  "textMultiple": "<p>O nei fomaʻi faapitoa uma o ni filifiliga lelei. Filifili se tasi, pe na o le fa'aauau i le “E leai se eseesega mo aʻu”.</p>",
  "textSingle": "<p>O lau fomaʻi masani – {{referral.gp}} – ua fautuaina oe i le:</p>",
  "titleMultiple": "Filifili lau fomaʻi faapitoa",
  "titleSingle": "Lau fomaʻi faapitoa",
  "viewProfile": "Vaʻai i le tala atoa"
}
